import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { FavoriteListing } from './types/FavoriteListing';
import { APIV2_URL } from './constants';

export type AddFavoriteListingCall = (
  listingId: number,
) => Promise<{ data: FavoriteListing }>;

export default (makeCall: MakeCall) => (listingId: number) =>
  makeCall<null>('POST', `${APIV2_URL}/listing/${listingId}/favorite`);
